export default __webpack_public_path__ + "static/media/ic_bosnia_and_herzegovina.e33c3418.svg";